export default {
  LIST: {
    TITLE: `Time off management`,
    SUMMARY: ``
  },
  FORM: {
    TITLE: ``,
    SUMMARY: ``
  },
  TIME_OFF: `Time off`,
  TIMEOFF_SUMMARY: `<0>{{ name }}</0> - {{ requestTypeName }} <1>({{ range }})</1>`,
  NO_TIMEOFF_TO_SHOW: `No time off requests to show.`,
  IMPORT_TIME_OFF: `Import time off`,
  CREATE: `Create a time off`,
  IN_PROGRESS: `In progress`,
  APPROVE: `Approve`,
  APPROVED: `Approved`,
  REFUSED: `Refused`,
  CANCELLED: `Cancelled`,
  APPROVED_MARKED: `Approved`,
  IN_PROGRESS_MARKED: `Put in progress`,
  REFUSED_MARKED: `Refused`,
  CANCELLED_MARKED: `Cancelled`,
  STATUS: `Status`,
  MANAGEMENT: `Management`,
  FIRST_COLUMN: ``,
  SECOND_COLUMN: ``,
  CREATED_BY_ON: `Created by <0>{{createdBy}}</0> on {{date}} <2>{{time}}</2>`,
  STATUS_PHRASE: `<0>{{status}}</0> by <1>{{validateBy}}</1> on {{date}} <3>{{time}}</3>`,
  COMMENT: `<0>{{count}} comment <2/></0>`,
  COMMENT_other: `<0>{{count}} comments <2/></0>`,
  TIME_OFFS_THIS_YEAR: `{{count}} time off requests made this year`,
  SEE_ALL_TIME_OFF: `Display all time off requests`,
  IS_LOADING_TIME_OFF: `Loading time off requests`,
  NO_CONFLICTS: `There are no conflicts with the schedule`,
  IS_LOADING_CONFLICTS: `Loading conflicts with the schedule.`,
  CONFLICTS_DURING_TIME_OFF: `{{count}} conflicts during the time off request.`,
  SEE_ALL_SCHEDULE_CONFLICTS: `Display schedule conflicts`,
  SEE_TIMEOFF_CONFIRMATION_STATUS: `View time off notification status`,
  TIMEOFF_CONFIRMATION_STATUS_MODAL: {
    TITLE: `Time off notification status`,
    SUMMARY: ``
  },
  DELETE: {
    TITLE: `Delete the time off request`,
    SUMMARY: `Are you sure you want to delete the time off request?`,
    PRIMARY_ACTION: `Delete the request`
  },
  csv: {
    TIMEOFF_CSV_NAME: `timeoff_export_{{date}}`,
    REQUEST_DATE: `Request date`,
    CREATED_BY: `Created by`,
    VALIDATION_DATE: `Validation date`,
    VALIDATED_BY: `Validated by`,
    START: `Start`,
    END: `End`,
    DATE: `Date`,
    VACATION_TYPE: `Time off type`,
    COMMENTS: `Comments`,
    PRIMARY_OCCUPATION: `Primary occupation`,
    SECONDARY_OCCUPATION: `Secondary occupation`,
    EMPLOYEE_NUMBER: `Employee number`,
    EMPLOYEE: `Employee`,
    STATUS: `Request status`
  },
  form: {
    CREATE: { TITLE: `Create a time off request`, SUMMARY: `` },
    EDIT: {
      TITLE: `Edit a time off request`,
      SUMMARY: ``
    },
    VIEW: {
      TITLE: `View a time off request`,
      SUMMARY: ``
    },
    VACATIONTYPEID: {
      LABEL: `Request type`,
      DESCRIPTION: ``
    },
    COMMENT: {
      LABEL: `Comment`,
      PLACEHOLDER: `Write a comment...`,
      DESCRIPTION: ``
    },
    USERID: {
      LABEL: `Employee`,
      DESCRIPTION: ``
    },
    PARTIALDATES: {
      LABEL: `Allow setting a start and end time, rather than full days.`,
      DESCRIPTION: `The start and end dates must be different.`
    },
    START: { LABEL: `Start`, PLACEHOLDER: ``, DESCRIPTION: `` },
    END: { LABEL: `End`, PLACEHOLDER: ``, DESCRIPTION: `` },
    COMMENT_REQUIRED: `The comment field is mandatory.`,
    REQUEST_TYPE_ID_REQUIRED: `The request type selection is mandatory.`,
    START_REQUIRED: `The start date is mandatory.`,
    END_REQUIRED: `The end date is mandatory.`,
    USER_REQUIRED: `The employee is mandatory.`,
    SUBMIT: `Submit`,
    QUIT_PAGE: `Your changes have not been saved. Are you sure you want to leave?`,
    END_BEFORE_START: `The end date must be after start date.`,
    SET_PARTIAL_DAYS: `Partial dates`,
    SET_PARTIAL_DAYS_DESC: `Allow setting a start and end time, rather than full days.`,
    START_END_MUST_BE_DIFFERENT: `The start and end dates must be different.`,
    REQUEST_OVERLAPPING_ANOTHER: `The dates entered are overlapping an already existing timeOff request for this employee.`,
    TIMEPAID: {
      LABEL: `Paid hours`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    }
  },
  import: {
    LINE: `Line`,
    VALIDATION: `Validation`,
    TITLE: {
      TITLE: `Import time off`,
      SUMMARY: ``
    },
    EMPLOYEE_NUMBER: `Employee number`,
    EMPLOYEENUMBER_DESC: `The employee number found in the employee file in Merinio.`,
    REQUEST_TYPE: `Request type`,
    REQUESTTYPE_DESC: `The request code as defined in request types by your administrator.`,
    START: `Start`,
    STARTDATE_DESC: `Start date in <1>YYYY-MM-DD</1> format, for example January 30th 2010  would be <1>2010-01-30</1>.`,
    STARTTIME: `Start time`,
    STARTTIME_DESC: `Start time in <1>HH:mm</1> format, for example 2PM would be <1>14:00</1>.`,
    END: `End`,
    ENDDATE_DESC: `End Date in the same format as start date.`,
    ENDTIME: `End time`,
    ENDTIME_DESC: `End time in the same format as start time.`,
    STATUS: `Status`,
    DOWNLOAD_TEMPLATE: `Download template`,
    MISSING_HEADERS: `Missing the following header: <0>{{value}}</0>`,
    MISSING_HEADERS_other: `Missing the following headers: <0>{{value}}</0>`,
    TEMPLATE_FILE_NAME: `time_off_import`,
    TIME_OFF_SAVING_FAILED: `There was <0>{{count}}</0> time off that were not saved.`,
    TIME_OFF_SAVING_FAILED_other: `There were <0>{{count}}</0> time off that were not saved.`,
    TIME_OFF_NOT_VALID: `There was <0>{{count}}</0> invalid time off.`,
    TIME_OFF_NOT_VALID_other: `There were <0>{{count}}</0> invalid time off.`
  },
  MULTI_CREATE_MODAL: {
    TITLE: `Create multiple time off requests`,
    SUMMARY: `For the following users`,
    SOME_FAILED: `One time off request was not created.`,
    SOME_FAILED_other: `{{count}} time off requests were not created.`
  }
}
